
import FiltersMenu from "@/components/filters/FilterMenus.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
     components: {
          FiltersMenu
     }
})
export default class DailyPay extends Vue {
     dispatch = this.$store.dispatch;
     selectedDynamicFilters: any | null = null;
     selectedStaticFilters: any | null = null;
     child: any | null = null;

     async mounted() {
          this.selectedStaticFilters = JSON.parse(localStorage.getItem("waitlistData") ?? "{}");
          this.child = await this.dispatch("child/getChildInfo", this.$router.currentRoute.params.id)
          this.selectedDynamicFilters = await this.dispatch("waitlistStore/getWaitlistFilters");
          if (this.selectedDynamicFilters?.paymentOptions) {
               this.selectedDynamicFilters.paymentOptions = this.selectedDynamicFilters.paymentOptions.sort(this.compareByValueAndThenByMaxValue);
          } 

          this.sendDataToFooter();
          this.sendDataToHeader();
     }

     groupScheduleAvailabilityEntriesByDays(scheduleAvailability: any[]) {
          if (scheduleAvailability){
               return scheduleAvailability.reduce((acc, curr) => {
                    const { day, timeOfDay } = curr;
                    const dayEntry = acc.find((entry: any) => entry.day === day);
                    if (dayEntry) {
                         dayEntry.times.push(timeOfDay);
                    } else {
                         acc.push({ day, times: [timeOfDay] });
                    }
                    return acc;
               }, []);
          }

          return [];
     }

     async saveWaitlistFilters() {
          const waitlistTicketId = this.$route.query.waitingListTicketId;
          const childId = this.$route.params.id;

          if (waitlistTicketId) {
               await this.$store.dispatch('waitlistStore/putWaitlistData', { childId, waitlistTicketId });
          } else {
               await this.$store.dispatch('waitlistStore/postWaitlistData', childId);
          }

          await this.$store.dispatch('waitlistStore/clearWaitlistData');
     }

     sendDataToHeader() {
          const path = `/waitlist/${this.$router.currentRoute.params.id}/daily-payment`

          this.$store.dispatch('waitlistStore/updateHeaderData', { pageList: [1, 2, 3, 4, 5, 6], activePages: 6, backPath: path});
     }

     sendDataToFooter() {
          const path = `/app/waitlist/children/${this.$router.currentRoute.params.id}/childcare-providers`;

          this.$store.dispatch('waitlistStore/updateFooterData', { btnName: 'Confirm', path, saveWaitlistFilters: this.saveWaitlistFilters, isQueryExcluded: true, isBtnDisabled: !this.waitlistDataIsValid });
     }

     get formattedDate(): string {
          if (!this.selectedStaticFilters?.RequestedStartDate) {
               return '';
          }

          const [day, month, year] = this.selectedStaticFilters.RequestedStartDate.split("-");
          const date = new Date(`${year}-${month}-${day}`);
          return date.toLocaleDateString("en-US", {
               year: "numeric",
               month: "long",
               day: "numeric"
          });
     }

     getFormattedPaymentOption(paymentOption: any): string {
          switch (paymentOption.paymentType) {
               case "Range":
                    return `$${paymentOption.value}-$${paymentOption.maxValue}`;
               case "LessThan":
                    return `< $${paymentOption.value}`;
               case "GreaterThan":
                    return `> $${paymentOption.value}`;
               case "CustomMessage":
                    return paymentOption.value;
          }

          return '';
     }

     compareByValueAndThenByMaxValue(dailyPayA: any, dailyPayB: any ) {
          const maxValueA = dailyPayA.maxValue === undefined ? -Infinity : dailyPayA.maxValue;
          const maxValueB = dailyPayB.maxValue === undefined ? -Infinity : dailyPayB.maxValue;

          return dailyPayA.value - dailyPayB.value || maxValueA - maxValueB;
     }

     get waitlistDataIsValid(): boolean {
          return this.selectedStaticFilters
               && this.selectedStaticFilters.ProviderTypes?.length > 0 
               && this.selectedStaticFilters.ChildcareTypes?.length > 0 
               && this.selectedStaticFilters.SchoolPlans?.length > 0 
               && this.selectedStaticFilters.PaymentOptions?.length > 0 
               && this.selectedStaticFilters.ScheduleAvailability?.length > 0 
     }

     dayAbbreviations = {
          Monday: "Mon",
          Tuesday: "Tue",
          Wednesday: "Wed",
          Thursday: "Thu",
          Friday: "Fri",
          Saturday: "Sat",
          Sunday: "Sun"
     };
}
